export type Props = {
  width?: number;
  height?: number;
  strokeWidth?: number;
};

const CloserIcon = ({ width = 23, height = 23, strokeWidth = 2 }: Props): JSX.Element => {
  return (
    <svg width={width} height={height} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.47559 21.7473L21.3206 1.34277"
        stroke="#3C3C3C"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3206 21.7473L1.47559 1.34277"
        stroke="#3C3C3C"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloserIcon;
